import React from 'react';
import { gql } from '@apollo/client';
import { Show, TabbedShowLayout, Tab, TextField, TabbedShowLayoutTabs } from 'react-admin';
import BillingGroupsTab from 'components/tabs/BillingGroupsTab';

const BillingGroupParentsShow = () => {
  return (
    <Show>
      <TabbedShowLayout tabs={<TabbedShowLayoutTabs variant="scrollable" />}>
        <Tab label="info">
          <TextField label="ID" source="id" />
          <TextField label="Name" source="name" />
        </Tab>
        <Tab label="Billing Groups" path="billing_groups">
          <BillingGroupsTab target="billing_group_parent_id" />
        </Tab>
      </TabbedShowLayout>
    </Show>
  );
};

BillingGroupParentsShow.query = gql`
  query GET_ONE($id: Int!) {
    billingGroupParent(id: $id) {
      id
      name
    }
  }
`;

export default BillingGroupParentsShow;
